// Vue setup
import Vue from 'vue';
import { loadProgressBar } from 'axios-progress-bar';
import 'babel-polyfill';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import IconButtonComponent from '@/components/icon-button/icon-button.component.vue';
import IconMenuComponent from '@/components/icon-menu/icon-menu.vue';
import App from '@/application/app/components/app/app.vue';
import initAuthenticationInterceptor from '@/application/authentication/axios-authentication-response-interceptor';
import { store } from '@/store';
import { router } from '@/router';
import vuetify from '@/plugins/vuetify';
import VueHighlightJS from 'vue-highlight.js';
// @ts-ignore
import xml from 'highlight.js/lib/languages/xml';
import 'highlight.js/styles/default.css';
import '@/plugins/font-awesome';
import '@/plugins/moment';
import '@/plugins/vuex-router-sync';
import '@/sass/app.sass';
import '@/filters';
import { clearAllStores } from '@/helpers/store-reset-helper';

Vue.component('icon-button', IconButtonComponent);
Vue.component('icon-menu', IconMenuComponent);

Vue.use(VueHighlightJS, {
  languages: {
    xml,
  }
});

Sentry.init({
  enabled: process.env.SENTRY_ENVIRONMENT === 'prod',
  environment: process.env.SENTRY_ENVIRONMENT,
  dsn: process.env.SENTRY_DSN,
  release: process.env.SOURCE_VERSION,
  integrations: [new Integrations.Vue({
    Vue,
    attachProps: true,
    logErrors: true
  })],
});

function initApplication(): void {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
    mounted: () => {
      loadProgressBar();
    }
  }).$mount('#app');
}

function initApplicationDependingOnAuthenticatedUser(): void {
  store.dispatch('authentication/fetchAuthenticatedUser', {})
    .catch(() => {
      clearAllStores();
    })
    .finally(() => {
      initApplication();
    });
}

initAuthenticationInterceptor();
initApplicationDependingOnAuthenticatedUser();
